export default "__VITE_ASSET__DHNdBzY8__"